import { useState } from "react";
import { ArrowUp, Mic, Square, Loader2 } from "lucide-react";

export const Composer = ({ onSend, onMic, micState = "idle", disabled, busy, onCancel, placeholder = "Ask Feerd anything, or ask it to research something…", autoFocus, size = "lg" }) => {
  const [text, setText] = useState("");
  const submit = (e) => {
    e?.preventDefault();
    const t = text.trim();
    if (!t || disabled) return;
    onSend(t);
    setText("");
  };
  const listening = micState === "listening";
  const transcribing = micState === "transcribing" || micState === "requesting";
  return (
    <form onSubmit={submit} data-testid="composer-form"
      className={`group relative flex items-end gap-3 bg-[#0f0f0f]/90 border border-[#2A2A2A] focus-within:border-[#D8BFD8]/50 transition-colors duration-300 shadow-[0_20px_60px_rgba(0,0,0,0.8)] ${size === "lg" ? "px-5 py-4" : "px-4 py-3"}`}>
      <textarea data-testid="composer-input" value={text} onChange={(e) => setText(e.target.value)} autoFocus={autoFocus} rows={1}
        onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) submit(e); }}
        placeholder={listening ? "Listening… tap the square to finish" : placeholder} aria-label="Message Feerd"
        className="flex-1 resize-none bg-transparent outline-none text-ivory placeholder:text-[#5f5f5f] text-sm md:text-base leading-relaxed max-h-40 py-1.5" />
      {onMic && (
        <button type="button" onClick={onMic} disabled={transcribing || busy} data-testid="composer-voice-button" aria-label={listening ? "Stop listening" : "Speak to Feerd"}
          className={`h-11 w-11 shrink-0 flex items-center justify-center rounded-full border transition-[background-color,border-color,transform] duration-200 hover:-translate-y-0.5 ${listening ? "bg-[#D8BFD8] border-[#D8BFD8] text-[#0A0A0A]" : "border-[#2A2A2A] text-[#C0C0C0] hover:border-[#C0C0C0]/60"} disabled:opacity-40`}>
          {transcribing ? <Loader2 className="h-4 w-4 animate-spin" strokeWidth={1.5} /> : listening ? <Square className="h-3.5 w-3.5" strokeWidth={1.5} fill="currentColor" /> : <Mic className="h-4 w-4" strokeWidth={1.5} />}
        </button>
      )}
      {busy && onCancel ? (
        <button type="button" onClick={onCancel} data-testid="composer-cancel-button" aria-label="Stop response"
          className="h-11 px-4 shrink-0 rounded-full border border-[#2A2A2A] text-[0.65rem] tracking-[0.2em] uppercase text-[#C0C0C0] hover:border-[#e2a6a6]/60 hover:text-[#e2a6a6] transition-colors duration-200">Stop</button>
      ) : (
        <button type="submit" disabled={!text.trim() || disabled} data-testid="composer-send-button" aria-label="Send message"
          className="h-11 w-11 shrink-0 flex items-center justify-center rounded-full bg-[#C0C0C0] text-[#0A0A0A] transition-[background-color,transform,opacity] duration-200 hover:bg-[#F8F4E6] hover:-translate-y-0.5 disabled:opacity-25 disabled:hover:translate-y-0">
          <ArrowUp className="h-4 w-4" strokeWidth={1.75} />
        </button>
      )}
    </form>
  );
};
